/* eslint-disable */
// @ts-nocheck
import { formatMoney, formatQuantity } from '~/widgets/CostBomDemo/format'
import { SAMPLE_UNITS } from '~/widgets/CostBomDemo/strings'

export function initHeroSampleFormat() {
  // The legacy engine reaches for this global; the module is the real owner.
  window.formatQuantity = formatQuantity

  function applyRowFormats() {
    var nodes = window.MI_NODES || {}
    document.querySelectorAll('.mi-tabpanel').forEach(function (panel) {
      var cfg =
        SAMPLE_UNITS[panel.getAttribute('data-panel')] || SAMPLE_UNITS.default
      panel.querySelectorAll('.mi-row[data-i]').forEach(function (row) {
        var node = nodes[row.getAttribute('data-i')]
        if (!node) return
        var vals = row.querySelectorAll('.mi-row__val')
        if (vals[0]) {
          var massNum = vals[0].querySelector('.num')
          if (massNum)
            massNum.textContent = formatQuantity(node.mass * cfg.massFactor)
        }
        if (vals[1]) {
          var costNum = vals[1].querySelector('.num')
          if (costNum) costNum.textContent = formatMoney(node.cost)
        }
      })
    })
  }

  window.applyRowFormats = applyRowFormats

  applyRowFormats()
}
